import React, { Component } from 'react';
import { CodetableListItemsProps } from './types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableItemRow } from './common/codetable-item-row';
import { CodetableListItemsContainer } from './codetable-list-items-container';
import { CodetableItem } from './codetable-item';
import { CodetableHeading } from 'app/area/codetable/list/list-items/codetable-heading';
import styles from './codetable-list-items.scss';

export class CodetableListItems extends Component<CodetableListItemsProps> {

  public render() {

    const { itemAccess, fetchingItemAccess, codetableId, codetableName, parentId, codeListBranch,
      codeListBranchState, codeId, isZebra, isHierarchyMode, isHierarchy, breadcrumbs, codeAccessConfiguration,
      deletingCodeItem, loadFromParent, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess,
      translation, treeDepthLevel, hierarchyMetadata, isMetadataSequence, addLinkFactory } = this.props;

    const currentBranch = codeListBranch.find(item => item.id === parentId);
    const currentCodeItem = currentBranch && currentBranch.items || [];

    const currentBranchState = codeListBranchState && codeListBranchState.find(state => state.id === parentId);
    const fetching = !!currentBranchState && !!currentBranchState.fetching;
    const needsReload = !!currentBranchState && !!currentBranchState.needsReload;

    return <>
      <CodetableListItemsContainer
        parentId={parentId}
        codeBranch={currentBranch}
        codeBranchState={currentBranchState}
        loadFromParent={loadFromParent}>
        {
          isMetadataSequence && treeDepthLevel === 0
            ? <CodetableHeading codetableName={codetableName} sequenceName={translation.sequence} isHierarchy={isHierarchyMode} />
            : null
        }
        {currentCodeItem.map((codeItem, index) => {

          const codeItemState = codeListBranchState && codeListBranchState.find(state => state.id === codeItem.id);
          const open = !!codeItemState && !!codeItemState.open;

          const showSpinner = !!codeItemState && codeItemState.isUpdatingParent && codeItemState.id === codeItem.id;

          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;

          const isLastChild = !!currentCodeItem && currentCodeItem.length === index + 1;

          const hasChildren = isHierarchyMode && !!codeItem.childrenCount;

          const hierarchyMetadataUpdated: HierarchyMetadata[] = [...hierarchyMetadata, {
            depthLevel: treeDepthLevel,
            hasChildren,
            isLastChild
          }];

          return <div key={codeItem.id} className={codeItem.deletingCodeItem ? styles.deleting : ''}>
            <CodetableItem
              itemAccess={itemAccess}
              fetchingItemAccess={fetchingItemAccess}
              breadcrumbs={breadcrumbs}
              isZebra={isZebraValue}
              hierarchyMetadata={hierarchyMetadataUpdated}
              treeDepthLevel={treeDepthLevel}
              codetableId={codetableId}
              codeId={codeId}
              refetching={fetching && needsReload || showSpinner}
              isHierarchyMode={isHierarchyMode}
              isHierarchy={isHierarchy}
              open={open}
              parentId={parentId}
              codeItem={codeItem}
              expandCodeItem={expandCodeItem}
              deleteCodeItem={deleteCodeItem}

              loadCodesAccess={loadCodesAccess}
              clearCodesAccess={clearCodesAccess}

              deletingCodeItem={deletingCodeItem || codeItem.deletingCodeItem}
              translation={translation}
              isLastChild={!open && isLastChild}
              codeAccessConfiguration={codeAccessConfiguration}

              addLinkFactory={addLinkFactory}
            />
            {open && <div>
              <CodetableListItems
                {...this.props}
                hierarchyMetadata={hierarchyMetadataUpdated}
                deletingCodeItem={codeItem.deletingCodeItem || deletingCodeItem}
                parentId={codeItem.id}
                treeDepthLevel={treeDepthLevel + 1}
                isZebra={isZebraValue}
              />
            </div>}
          </div>;
        })}
      </CodetableListItemsContainer>
      {fetching && !needsReload && <CodetableItemRow isZebra={isZebra} isLoader>
        <CodetableItemLoader>
          {translation.loading}
        </CodetableItemLoader>
      </CodetableItemRow>}
    </>;
  }
}
